<template>
    <!--网授课程模块-->
    <div class="onlineCourseAllCont">
        <!-- 学习进度 -->
        <net-class-pross v-show='netClassData.courses' :year='year_value' :netClassData='netClassData'>
        </net-class-pross>

        <div class="courseType-tips">{{courseTypeJson.msg1}}</div>

        <!-- 报名课程列表 -->
        <!-- v-if='!loading && courseList.length' -->
        <div :class="loading ? 'classList' : ''" v-loading='loading'>
            <div v-if='!loading && courseList.length'>
                <div v-show="tabShow == 0">
                    <div class="compulsoryCourseCont">

                        <p class="compulsoryCourseTitle">必修课</p>
                        <ul class="compulsoryCourseList">
                            <!-- v-for='courseList' -->
                            <li v-for='item in courseList' :key='item.cid' v-if='item.course_type == 1'>
                                <div class="compulsoryCourseImg fl">
                                    <img :src="item.thumb" />
                                </div>
                                <div class="compulsoryCourseImgInfor  fl">
                                    <p class="compulsoryCourseImgTitle textCut">
                                        {{item.name}}
                                    </p>
                                    <p class="compulsoryCourseScore">学时：{{item.class_hour}}</p>
                                </div>

                                <div class="studenInterest">
                                    <span class="alreadyJoinBtn blueGradient" @click="tryIt(item.cid)">试看</span>
                                </div>

                            </li>
                        </ul>
                    </div>

                    <div class="electiveCoursesCont">
                        <p class="compulsoryCourseTitle">选修课</p>

                        <ul class="compulsoryCourseList">
                            <li v-for='item in courseList' :key='item.cid' v-if='item.course_type == 2'>
                                <div class="compulsoryCourseImg fl">
                                    <img :src="item.thumb" />
                                </div>
                                <div class="compulsoryCourseImgInfor  fl">
                                    <p class="compulsoryCourseImgTitle textCut">
                                        {{item.name}}
                                    </p>
                                    <p class="compulsoryCourseScore">学时：{{item.class_hour}}</p>
                                </div>

                                <div class="studenInterest">
                                    <span class="trySeeBtn buttonBorderStyle" @click="tryIt(item.cid)">试看</span>

                                    <!-- <span class="joinLearnBtn"  v-if='isJoin(item)'>已加入</span> -->
                                    <span class="joinLearnBtn" @click='addStudy(item)' v-if='isJoin(item) '>加入学习</span>
                                    <span class="alreadyJoinBtn blueGradient" @click='cancelStudy(item.cid,item.credit,item.class_hour)'
                                        v-else>取消学习</span>
                                </div>

                            </li>
                        </ul>

                    </div>

                    <div class="chooseResultCont">
                        <p>您当前已选择，课程：<span>{{ selectedNum }}</span>门 学时：<span>{{ studyHours }}</span></p>
                        <el-row class="center">
                            <el-button :loading='signUpLoading' v-if='netClassData && (netClassData.courses.length==0 || (netClassData.courses.length>0 && netClassData.need_all==2))' class="signUpNowBtn blueGradient"
                                @click="signUp()">立即报名
                            </el-button>
                        </el-row>
                    </div>


                    <div class="chooseResultContH">

                    </div>
                </div>
            </div>
        </div>

        <div v-if='!loading && !courseList.length' class="emptyClass">暂无课程</div>

        <!--网授课确认报名-->
        <div class="onlineConfirmSignUp" v-show="tabShow == 1">
            <div class="compulsoryCourseCont">
                <p class="compulsoryCourseTitle confirmSignUpTitle">
                    <span>学时：<font>{{studyHours}}</font></span> <span>课程：<font>{{selectedNum}}门</font></span></p>
                <div class="faceCompulsoryCourseList">
                    <ul class="faceCourseAddressList  classScheduleList">
                        <li v-for='item in selectedCourseList' :key='item.cid' v-if='item.course_type == 1'>
                            <span class="classScheduleTitle textCut">【必修】{{item.name}}</span>
                            <span class="classScheduleTeacher">学时：{{item.class_hour}}</span>
                        </li>
                    </ul>
                </div>

                <div class="dividingLine"></div>

                <div class="faceCompulsoryCourseList">
                    <ul class="faceCourseAddressList  classScheduleList">
                        <li v-for='item in selectedCourseList' :key='item.cid' v-if='item.course_type == 2'>
                            <span class="classScheduleTitle textCut">【选修】{{item.name}}</span>
                            <span class="classScheduleTeacher">学时：{{item.class_hour}}</span>
                        </li>
                    </ul>
                </div>

                <div class="onlineConfirmSignUpBtns">
                    <p class="blueGradient continueSelectOnlineCourse" @click="continueSelect">继续选课
                    </p>
                    <el-button type="primary" class="blueGradient" :loading="confirmLoading" @click="confirmSignup">确认报名
                    </el-button>

                    <!-- <p class="blueGradient confirmSignUpOnlineCourse" @click="confirmSignup()">确认报名</p> -->
                </div>
            </div>
        </div>

        <!--  该学年学分已超出提示 -->
        <el-dialog title="提示" class="overflow" center :visible.sync="rule" width='30%' :before-close="ruleClose">
            <p>{{year_value}}学年要求完成专业科目{{valiData.year_class_hour}}学时</p>
            <p>您该学年学时已超出，</p>
            <p>请点击“继续选课”返回重新选课。</p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="rule = false">确 定</el-button>
            </span>
        </el-dialog>

        <common-confirm @sure='sure' @signUp="signUp"></common-confirm>
    </div>
</template>
<script>
import commonConfirm from "../../common/confirm.vue";
import netClassPross from "../myCourse/netClassPross.vue";
export default {
    props: {
        courseList: {
            type: Array
        },
        year_value: {
            year_value: String
        },
        car: {
            car: String
        },
        netClassData: {
            type: Object
        },
        courseTypeJson:{
          type: Object
        }
    },
    components: {
        commonConfirm,
        netClassPross
    },
    computed: {
        isJoin () {

            return (course) => {
                let isTrue = false;
                this.selectStudyClass.map(item => {
                    if (item.cid == course.cid) {
                        isTrue = true;
                    }
                })
                if (isTrue) {
                    return false;
                }
                return true;
            }
        },

    },
    data () {
        return {
            rule: false,
            loading: true,
            confirmLoading: false,//确认报名loading
            selectedCourseList: [],
            selectStudyClass: [],
            selectedNum: 0,//当前选择了几门课程
            studyScore: 0.0,//当前选择课程的学分
            studyHours:0, //当前选择课程的学时

            tabShow: '0',

            signUpLoading: false,

            price: 0,

            valiData: {},

        }
    },
    watch: {
        courseList () {

                this.loading = false;

                let credit = 0;
                let hours = 0
                let length = 0;
                this.courseList.map(item => {
                    if (item.course_type == 1) {
                        credit += Number(item.credit);
                        hours += Number(item.hours);
                        length += 1;
                    }
                })
                this.studyScore = credit;
                this.studyHours = hours
                this.selectedNum = length;
        },
        car () {
            if (this.car) {
                let carFlg = this.car.split(',');
                if (carFlg) {
                    this.courseList.map((item) => {
                        if (item.course_type == 2) {
                            if (carFlg.indexOf(String(item.cid)) != -1) {
                                this.addStudy(item,1)
                            }
                        }
                    })
                }
            }
        },
        tabShow () {
            this.$emit('hideYear', this.tabShow);
        }
    },
    mounted () {


    },
    methods: {
        /**
         * 切换年份清空
         */
        clearSelectedCourse () {
            this.selectedNum = 0;
            this.studyScore = 0;
            this.studyHours = 0;
            this.selectStudyClass = [];
        },
        /**
         * 关闭超出限制弹窗
         */
        ruleClose () {
            this.rule = false;
        },

        /**
         * 立即报名
         */
        signUp () {

            this.selectedCourseList = [];
            //必修
            this.courseList.map(item => {
                if (item.course_type == 1) {
                    this.selectedCourseList.push(item);
                }
            })
            //选修
            this.selectStudyClass.map(item => {
                this.selectedCourseList.push(item);
            })

            if (!this.selectedCourseList.length) {
                this.$message('您还没有选择要学习的课程');
                return false;
            }

            let cids = '';
            this.selectedCourseList.map(item => {
                cids += item.cid + ','
            })
            if (cids) {
                cids = cids.slice(0, cids.length - 1);
            }
            let params = {
                cids: cids,
                year: this.year_value
            };
            this.signUpLoading = true;
            this.$store.dispatch('signup_once', params).then((res) => {
                if (res.code == 200) {
                    // this.$message({
                    //     message: '报名成功',
                    //     type: 'success'
                    // });
                    this.tabShow = 1;
                }
                this.signUpLoading = false;
            }).catch(() => {
                this.signUpLoading = false;
            })
        },
        /**
         * 加入学习
         */
        addStudy (item,c) {
            this.selectedNum = ++this.selectedNum;

            this.studyScore = Number(this.studyScore) + Number(item.credit);
            this.studyScore = Number(this.studyScore).toFixed(1);

            this.studyHours = Number(this.studyHours) + Number(item.class_hour);
            this.studyHours = Number(this.studyHours).toFixed(1);
            this.selectStudyClass.push(item);

            var courseTypeJson=this.courseTypeJson
            if(courseTypeJson.need_all==1){
              console.log('c',c)
              if(c!=1 && this.studyHours>=60){
                let target = {
                    public_model_show: true,
                    public_model_text: '<p>你已选够60个学时，你可以取消继续添加课件或确定报名</p>',
                    public_model_param: {
                      checkHours:true
                    }
                }
                this.$store.commit("show_public_model", target);
              }
            }
        },
        /**
         * 取消学习
         */
        cancelStudy (cid, credit,class_hour) {
            this.selectedNum = --this.selectedNum;
            this.studyScore = this.studyScore - credit;
            this.studyScore = Number(this.studyScore).toFixed(1);

            this.studyHours = this.studyHours - class_hour;;
            this.studyHours = Number(this.studyHours).toFixed(1);

            this.selectStudyClass = this.selectStudyClass.filter(item => item.cid != cid);
        },
        /**
         * 继续选课
         */
        continueSelect () {
            this.tabShow = 0;
        },



        /**
         * 确认报名
         */
        confirmSignup () {
            let params = {
                cids: this.getCids(),
                year: this.year_value,
                hours:this.studyHours
            };

            this.confirmLoading = true;
            this.$store.dispatch('validate', params).then((res) => {
                if (res.code == 200) {
                    var courseTypeJson=this.courseTypeJson
                    if(courseTypeJson.need_all==1){



                    if (res.data.remain_class_hour < 0) {

                        this.rule = true;
                    } else if (res.data.current_class_hour < res.data.year_class_hour) {
                        let html = `<p>${this.year_value}学年要求完成专业科目${res.data.year_class_hour}学时，</p>
                                    <p>本次所选课程含${res.data.current_class_hour}学时</p>
                                    <p>完成本学年专业科目学学时还差${res.data.remain_class_hour}学时</p>
                                    <p>请点击“继续选课”返回重新选课</p>
                                    `;
                        let target = {
                            public_model_show: true,
                            public_model_text: html,
                            public_model_param: {}
                        }
                        this.$store.commit("show_public_model", target);

                    } else {
                        let html = `${res.data.msg2}`;
                        let target = {
                            public_model_show: true,
                            public_model_text: html,
                            public_model_param: {}
                        }
                        this.$store.commit("show_public_model", target);
                        this.price = res.data.current_money;
                    }

                    }else{

                        let html = `${res.data.msg2}
                                    `;
                        let target = {
                            public_model_show: true,
                            public_model_text: html,
                            public_model_param: {},

                        }
                        this.$store.commit("show_public_model", target);
                        this.price = res.data.current_money;


                    }
                    this.valiData = res.data;
                }
                this.confirmLoading = false;
            }).catch(error => {
                this.confirmLoading = false;
            })
        },
        /**
         * 获取cids
         */
        getCids () {
            let cids = '';
            this.selectedCourseList.map(item => {
                cids += item.cid + ','
            })
            if (cids) {
                cids = cids.slice(0, cids.length - 1);
            }
            return cids;
        },

        /**
         * 跳转支付
         */
        sure () {
            console.log(this.valiData);
            if(this.courseTypeJson.need_all==1 && this.valiData.current_class_hour < this.valiData.year_class_hour){
              //alert('所选课件不符合报名要求，请联系客服');
              return false;
              console.log(1112222)
            }else{

            }

            let netClassPayData = {
                year: this.year_value,
                cids: this.getCids(),
                type: 1,
                price: this.price
            }
            localStorage.setItem('netClassPayData', JSON.stringify(netClassPayData));
            localStorage.setItem('selectedCourseList', JSON.stringify(this.selectedCourseList));
            this.$router.push('/pay');

        },
        /**
         * 试看
         */
        tryIt (cid) {
            this.$router.push({
                name: 'videoLearning',
                query: {
                    tryIt: '1',
                    cid: cid
                }
            })
        }
    }
}
</script>
<style lang="stylus" scoped>
.classList
    min-height 200px
.emptyClass
    padding-top 20px
    text-align center
    padding-top 100px
.studenInterest
    position absolute
    right 10px
    bottom 20px
    font-size 14px
.studenInterest span
    display inline-block
    width 72px
    height 26px
    line-height 26px
    /* color:#0173FF; */
    text-align center
    border-radius 4px
    cursor pointer
    margin-right 20px
.studenInterest span.joinLearnBtn
    background #fff
    color rgb(31, 132, 255)
    border 1px solid rgb(31, 132, 255)
.onlineTeachingContRight
    background #fff
    /* box-shadow:0px 0px 15px 0px rgba(218,218,218,0.5);
    position:relative;
    left:-2px; */
.onlineTeachingCont
    /* overflow: hidden; */
    padding-bottom 50px
.onlineTeachingContPadding
    /* padding:50px; */
    background #fff
    border-radius 4px
.classTypesTab, .onlineConfirmSignUpBtns
    overflow hidden
    margin 0 auto
    text-align center
.classTypesTab > p
    display inline-block
    margin 0 35px
    width 110px
    height 38px
    line-height 38px
    text-align center
    color #0173ff
    font-size 16px
    letter-spacing 2px
    border 1px solid #43affc
    border-radius 4px
    cursor pointer
.onlineConfirmSignUpBtns
    margin-top 100px
    p
        display inline-block
        margin 0 35px
        width 140px
        height 40px
        line-height 40px
        text-align center
        font-size 16px
        letter-spacing 2px
        border 1px solid #43affc
        border-radius 4px
        cursor pointer
    .el-button
        width 140px
.classTypesTab > p.active
    background-image -webkit-linear-gradient(left, #4bb7fc, #0173ff)
    background-image -o-linear-gradient(left, #4bb7fc, #0173ff)
    background-image -ms-linear-gradient(left, #4bb7fc, #0173ff)
    background-image linear-gradient(left, #4bb7fc, #0173ff)
    color #fff
    border none
.onlineTeachingContTop
    position relative
.classTypesSelect
    position absolute
    left 0px
    top 0
.compulsoryCourseCont
    margin-top 50px
.compulsoryCourseTitle
    font-size 18px
    color #333
    padding-left 10px
    // border-left 4px solid #0173ff
    font-weight bold
    // line-height 20px
    background-image $menu_border
    background-repeat no-repeat
    background-size 4px 22px
    background-position 0 1px
.compulsoryCourseList
    margin 0 5px 0 10px
.compulsoryCourseList li
    padding 10px
    overflow hidden
    border-radius 8px
    margin-top 20px
    background rgba(255, 255, 255, 1)
    box-shadow 0px 0px 15px 0px rgba(218, 218, 218, 0.5)
    position relative
.compulsoryCourseImg img
    width 105px
    height 80px
    display block
.compulsoryCourseImgInfor
    max-width 55%
    margin-left 15px
.compulsoryCourseImgTitle
    width 100%
    color #333
    font-weight bold
.compulsoryCourseImgTitle, .compulsoryCourseScore
    margin-top 12px
.compulsoryCourseScore
    color #666
    font-size 14px
.electiveCoursesCont
    margin-top 50px
.chooseResultCont
    background rgba(228, 240, 253, 1)
    height 60px
    line-height 42px
    color #333
    text-align center
    font-size 14px
    position fixed
    width 100%
    bottom 0px
    left 0px
    z-index 100
    display flex
    justify-content center
    align-items center
.chooseResultContH
    width 100%
    height 60px
.signUpNowBtn
    height 42px
    line-height 42px
    text-align center
    color #fff
    width 190px
    margin 0
    border-radius 4px
    cursor pointer
    letter-spacing 2px
    padding 0
    margin-left 100px
.blueGradient
    background-image -webkit-linear-gradient(left, #4bb7fc, rgb(31, 132, 255))
    background-image -o-linear-gradient(left, #4bb7fc, rgb(31, 132, 255))
    background-image -ms-linear-gradient(left, #4bb7fc, rgb(31, 132, 255))
    background-image linear-gradient(left, #4bb7fc, rgb(31, 132, 255))
    color #fff
.buttonBorderStyle
    color #0173ff
    border 1px solid #0173ff
.selectClassesList .compulsoryCourseImgInfor
    position relative
    top -6px
.signUpStatus
    position absolute
    top 25px
    color #999
    font-size 12px
    right 35px
.selectClassesList
    margin-top 40px
.faceCourseDetail
    margin 30px 30px 0 15px
.faceCourseDetail > p
    color #333
    line-height 24px
    margin-top 10px
    font-size 14px
.classScheduleTitle
    width 78%
    float left
.classScheduleTeacher
    float left
    margin-left 50px
.confirmSignUpTitle span
    margin-right 50px
.confirmSignUpTitle span font
    color #0475ff
.dividingLine
    height 12px
    background rgba(248, 248, 248, 1)
.onlineCourseConfirmSignUpPop, .coverLayer
    position fixed
    left 0
    right 0
    top 0
    bottom 0
    width 100%
    height 100%
    background rgba(0, 0, 0, 0.5)
.onlineCourseConfirmSignUpPopCont
    position fixed
    width 1050px
    padding 50px 35px
    box-sizing border-box
    -moz-box-sizing border-box
    left 50%
    top 50%
    transform translate(-50%, -50%)
    background #fff
    border-radius 4px
.closeBtn
    position absolute
    right 12px
    top 5px
    font-size 32px
    cursor pointer
.closeBtn:hover
    color #0475ff
.classScheduleTitle
    width 78%
    float left
.classScheduleTeacher
    float left
    margin-left 50px
.faceCourseAddressList li
    height 50px
    line-height 50px
    color #666
    font-size 16px
    border-bottom 1px solid rgba(238, 238, 238, 1)
    padding 0 5px
    cursor pointer
.center
    text-align center

.courseType-tips{
  margin-top 20px
  font-size 15px
  color red
}
</style>
<style lang="stylus">
.overflow
    p
        text-align center
</style>



// WEBPACK FOOTER //
// src/components/my/signStudy/netClass.vue